import React from "react";
import App from "./Component/App"
import ReactDOM from "react-dom/client";



let root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
    <App />
)